// ProjectIdUrlSync.tsx  (bättre namn vore ReportIdUrlSync)
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { setCurrentReportIdInRedux } from "./reportSlice";

const extractReportId = (pathname: string): string | null => {
  const m = /^\/project\/[^/]+\/reports\/([^/]+)(?:\/.*)?$/.exec(pathname);
  return m?.[1] ?? null;
};

const ReportIdUrlSync = () => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();

  const currentReportId = useAppSelector((state) => state.reportReducer.currentReportId);

  useEffect(() => {
    const id = extractReportId(pathname);
    if (currentReportId !== id) {
      dispatch(setCurrentReportIdInRedux(id));
    }
  }, [dispatch, pathname, currentReportId]);

  return null;
};

export default ReportIdUrlSync;
